import { Icon } from "@iconify/react";
import { Avatar, Button } from "@mui/material";
import { Popover, Transition } from "app/headlessui";
import Link from "components/Link";
import SwitchDarkMode2 from "components/SwitchDarkMode/SwitchDarkMode2";
import { Fragment } from "react";
import { FaPenNib } from "react-icons/fa";
import { ImStatsDots } from "react-icons/im";
import { MdAutoStories, MdLeaderboard, MdOutlineManageHistory } from "react-icons/md";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useSelectors } from "redux-store/selectors";
import { stringAvatar } from "utils/AvatarUtils";


export default function AvatarDropdown() {
  const { user } = useSelectors();
  const navigate = useNavigate();
  console.log(user, "user");

  const signout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  const NoLoggedUserMenu = () => {
    return (
      <div className="overflow-hidden rounded-3xl shadow-lg ring-1 ring-black ring-opacity-5">
        <div className="relative grid grid-cols-1 gap-3 bg-white dark:bg-neutral-800 py-7 px-6">
          <span className="font-bold">Get Started On FinancialX</span>
          <Button variant={"contained"} onClick={() => navigate("/signup")}>
            Sign Up
          </Button>
          <Button variant={"outlined"} onClick={() => navigate("/login")}>
            Sign In
          </Button>
        </div>
      </div>
    );
  };

  return (
    <div className="AvatarDropdown ">
      <Popover className="relative">
        {({ open, close }) => (
          <>
            <Popover.Button
              className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 focus:outline-none flex items-center justify-center`}
            >
              <svg
                className=" w-6 h-6"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M20.5899 22C20.5899 18.13 16.7399 15 11.9999 15C7.25991 15 3.40991 18.13 3.40991 22"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-10 w-screen max-w-[260px] px-4 mt-3.5 right-0 sm:px-0">
                {!user ? (
                  <NoLoggedUserMenu />
                ) : (
                  <div className="overflow-hidden rounded-3xl shadow-lg ring-1 ring-black ring-opacity-5">
                    <div className="relative grid grid-cols-1 gap-6 bg-white dark:bg-neutral-800 py-7 px-6">
                      <RouterLink
                        to={`/author/${user?.userName}/${user?._id}`}
                        replace={true}
                        state={{ username: user?.userName, userId: user?._id }}
                        className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                        onClick={() => close()}
                      >
                        <div className="flex items-center space-x-3">
                          <Avatar
                            src={user?.profileImage || ""}
                            {...stringAvatar(`${user?.name}`)}
                          />
                          <div className="flex-grow">
                            <h4 className="font-semibold">{user?.name}</h4>
                            <p className="text-xs mt-0.5">
                              {user?.currentLocation}
                            </p>
                          </div>
                        </div>
                      </RouterLink>
                      <div className="w-full border-b border-neutral-200 dark:border-neutral-700" />

                      {/* ------------------ 1 --------------------- */}
                      <Link
                        href={"/my-account/edit-profile"}
                        className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                        onClick={() => close()}
                      >
                        <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.1601 10.87C12.0601 10.86 11.9401 10.86 11.8301 10.87C9.45006 10.79 7.56006 8.84 7.56006 6.44C7.56006 3.99 9.54006 2 12.0001 2C14.4501 2 16.4401 3.99 16.4401 6.44C16.4301 8.84 14.5401 10.79 12.1601 10.87Z"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7.15997 14.56C4.73997 16.18 4.73997 18.82 7.15997 20.43C9.90997 22.27 14.42 22.27 17.17 20.43C19.59 18.81 19.59 16.17 17.17 14.56C14.43 12.73 9.91997 12.73 7.15997 14.56Z"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="ml-4">
                          <p className="text-sm font-medium ">{"My Account"}</p>
                        </div>
                      </Link>
                      {/* {user.role === "reader" ? (
                        <Link
                          href={"/become-a-writer"}
                          className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                          onClick={() => close()}
                        >
                          <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                            <Icon icon="fluent:form-new-20-filled" width={25} />
                          </div>
                          <div className="ml-4">
                            <p className="text-sm font-medium ">
                              Become a writer
                            </p>
                          </div>
                        </Link>
                      ) : ( */}
                        <Link
                          href={"/write"}
                          className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                          onClick={() => close()}
                        >
                          <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                            <FaPenNib size={23} />
                          </div>
                          <div className="ml-4">
                            <p className="text-sm font-medium ">Write</p>
                          </div>
                        </Link>
                      {/* )} */}
                      <Link
                        href={"/manage-interests"}
                        className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                        onClick={() => close()}
                      >
                        <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                          <MdOutlineManageHistory size={25} />
                        </div>
                        <div className="ml-4">
                          <p className="text-sm font-medium ">
                            {"Manage Interests"}
                          </p>
                        </div>
                      </Link>
                      <Link
                        href={"/stories"}
                        className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                        onClick={() => close()}
                      >
                        <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                          <MdAutoStories size={25} />
                        </div>
                        <div className="ml-4">
                          <p className="text-sm font-medium ">
                            {"Stories"}
                          </p>
                        </div>
                      </Link>
                      {/* <Link
                        href={"/leaderboard"}
                        className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                        onClick={() => close()}
                      >
                        <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                          <MdLeaderboard size={25} />
                        </div>
                        <div className="ml-4">
                          <p className="text-sm font-medium ">
                            {"Leaderboard"}
                          </p>
                        </div>
                      </Link> */}

                      <Link
                        href={"/stats"}
                        className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                        onClick={() => close()}
                      >
                        <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                          <ImStatsDots size={25} />
                        </div>
                        <div className="ml-4">
                          <p className="text-sm font-medium ">{"Stats"}</p>
                        </div>
                      </Link>

                      {user.role === "admin" && (
                        <Link
                          href={`http://localhost:3030/authenticating/${user._id}`}
                          className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                          onClick={() => close()}
                        >
                          <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                            <Icon
                              icon="ic:round-admin-panel-settings"
                              width={30}
                            />
                          </div>
                          <div className="ml-4">
                            <p className="text-sm font-medium">
                              Navigate to Admin Portal
                            </p>
                          </div>
                        </Link>
                      )}

                      <div className="w-full border-b border-neutral-200 dark:border-neutral-700" />

                      {/* ------------------ 2 --------------------- */}
                      <div className="flex items-center justify-between p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50">
                        <div className="flex items-center">
                          <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12.0001 7.88989L10.9301 9.74989C10.6901 10.1599 10.8901 10.4999 11.3601 10.4999H12.6301C13.1101 10.4999 13.3001 10.8399 13.0601 11.2499L12.0001 13.1099"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M8.30011 18.0399V16.8799C6.00011 15.4899 4.11011 12.7799 4.11011 9.89993C4.11011 4.94993 8.66011 1.06993 13.8001 2.18993C16.0601 2.68993 18.0401 4.18993 19.0701 6.25993C21.1601 10.4599 18.9601 14.9199 15.7301 16.8699V18.0299C15.7301 18.3199 15.8401 18.9899 14.7701 18.9899H9.26011C8.16011 18.9999 8.30011 18.5699 8.30011 18.0399Z"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M8.5 22C10.79 21.35 13.21 21.35 15.5 22"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="ml-4">
                            <p className="text-sm font-medium ">
                              {"Dark theme"}
                            </p>
                          </div>
                        </div>
                        <SwitchDarkMode2 />
                      </div>
                      <Link
                        href={"/#"}
                        className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                        onClick={() => close()}
                      >
                        <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.90002 7.55999C9.21002 3.95999 11.06 2.48999 15.11 2.48999H15.24C19.71 2.48999 21.5 4.27999 21.5 8.74999V15.27C21.5 19.74 19.71 21.53 15.24 21.53H15.11C11.09 21.53 9.24002 20.08 8.91002 16.54"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M15 12H3.62"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M5.85 8.6499L2.5 11.9999L5.85 15.3499"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="ml-4" onClick={signout}>
                          <p className="text-sm font-medium ">{"Log out"}</p>
                        </div>
                      </Link>
                    </div>
                  </div>
                )}
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
}
